export default __webpack_public_path__ + "static/media/icon_right_simple_16_Regular_grey.8cf73440.svg";